import { render, staticRenderFns } from "./CompareResult.vue?vue&type=template&id=2d3f5148"
import script from "./CompareResult.vue?vue&type=script&lang=js"
export * from "./CompareResult.vue?vue&type=script&lang=js"
import style0 from "./CompareResult.vue?vue&type=style&index=0&id=2d3f5148&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports